/**
 * Horizontal Scroll on navigation.
 *
 * @param {event} scrollContainer Object
 * @returns {void}
 */
export const horizontalScroll = ( scrollContainer ) => {
	if ( scrollContainer ) {
		let position = {
			left: 0,
			x: 0,
		};
		/**
		 *
		 * @param {object} e event object.
		 */
		const mouseDownHandler = ( e ) => {
			position = {
				left: scrollContainer.scrollLeft,
				x: e.clientX,
			};
			scrollContainer.style.cursor = 'grabbing';
			scrollContainer.style.userSelect = 'none';

			document.addEventListener( 'mousemove', mouseMoveHandler );
			document.addEventListener( 'mouseup', mouseUpHandler );
		};

		/**
		 *
		 * @param {object} e event object.
		 */
		const mouseMoveHandler = ( e ) => {
			const distanceMovedX = e.clientX - position.x;

			scrollContainer.scrollLeft = position.left - distanceMovedX;
		};

		/**
		 * Reset all when mouse released.
		 */
		const mouseUpHandler = () => {
			document.removeEventListener( 'mousemove', mouseMoveHandler );
			document.removeEventListener( 'mouseup', mouseUpHandler );

			scrollContainer.style.cursor = 'grab';
			scrollContainer.style.removeProperty( 'user-select' );
		};

		scrollContainer.addEventListener( 'mousedown', mouseDownHandler );
	}
};
